
import { FirearmStorageLocationMetadataBase } from './firearm-storage-location.metadata.base';


export class FirearmStorageLocationMetadata extends FirearmStorageLocationMetadataBase {
  constructor() {
    super();
  }
}

export const FIREARM_STORAGE_LOCATION_METADATA: FirearmStorageLocationMetadata = new FirearmStorageLocationMetadata();


